export default __webpack_public_path__ + "static/media/infographie_etapes_1.ff4d962e.png";